"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _designSystem = require("@superlogica/design-system");

var _styles = require("./styles");

var TableBody = function TableBody(_ref) {
  var columnAlign = _ref.columnAlign,
      getTableBodyProps = _ref.getTableBodyProps,
      prepareRow = _ref.prepareRow,
      rows = _ref.rows;
  return /*#__PURE__*/_react.default.createElement(_styles.TBody, getTableBodyProps(), rows.map(function (row) {
    prepareRow(row);
    return /*#__PURE__*/_react.default.createElement("tr", row.getRowProps(), row.cells.map(function (cell) {
      return /*#__PURE__*/_react.default.createElement(_designSystem.Text, Object.assign({
        as: "td"
      }, cell.getCellProps(), {
        align: columnAlign[cell.column.id]
      }), cell.render('Cell'));
    }));
  }));
};

var _default = TableBody;
exports.default = _default;